<template>
  <div class="tabs-wrap">
    <div class="tabs__header">
      <tab-nav :panes="panes" :currentName="modelValue" :plr="plr"></tab-nav>
    </div>
    <div class="tabs__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import tabNav from './tab-nav.vue'
export default {
  components: {
    tabNav,
  },
  props: {
    modelValue: {
      type: [Number, String],
      default: 0,
    },
    //未选中label颜色
    inactiveColor: {
      type: String,
      default: '#aaa',
    },
    // 选中label颜色
    activeColor: {
      type: String,
      default: '#333',
    },
    // 选中label底部线的颜色
    activeLineColor: {
      type: String,
      default: '#ff5500',
    },
    plr: {
      type: [Number, String],
      default: 40,
    },
  },
  emits: ['update:modelValue', 'tab-click'],
  data() {
    return {
      panes: [],
    }
  },
  mounted() {
    this.calcPaneInstances()
  },
  provide() {
    return {
      rootTabs: this,
    }
  },
  methods: {
    change(v) {
      this.$emit('update:modelValue', v)
      this.$emit('tab-click', v)
    },
    calcPaneInstances(isForceUpdate = false) {
      let defaultSlots = this.$slots.default()
      if (defaultSlots) {
        const panes = defaultSlots.filter(
          (vnode) => vnode.type && vnode.type.name === 'TabPane'
        )
        const panesChanged = !(
          panes.length === this.panes.length &&
          panes.every((pane, index) => pane === this.panes[index])
        )
        if (isForceUpdate || panesChanged) {
          this.panes = panes
        }
      } else if (this.panes.length !== 0) {
        this.panes = []
      }
    },
  },
}
</script>

<style lang="less" scoped>
.tabs-wrap {
  background-color: #fff;
  text-align: left;
}
.tabs__content {
  padding: 20px;
}
</style>